import { useState, useEffect } from 'react';
import { ProductEditPage } from './seller/ProductEditPage';
import { DesktopProductEditPage } from './desktop/DesktopProductEditPage';

export function ResponsiveProductEditPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <ProductEditPage /> : <DesktopProductEditPage />;
}